export default __webpack_public_path__ + "static/media/warningIcon.c773570a.svg";